import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_nolayout/public-page')({
  component: RouteComponent,
})

function RouteComponent() {
  return <div>Hello "/_nolayout/public-page"!</div>
}
